export const MFA_APP_KEY = 'authenticator';
export const MFA_SMS_KEY = 'sms';
export const MFA_EMAIL_KEY = 'email';

const MFA_AUTHENTICATOR_DESCRIPTORS = [
  {
    kind: MFA_APP_KEY,
    value: MFA_APP_KEY,
    label: 'Authenticator App',
    buttonLabel: 'Set Up Authenticator App',
    tooltip:
      'An authenticator app is typically installed on a mobile device and generates a security code in a specific time window.'
  },
  {
    kind: MFA_EMAIL_KEY,
    value: MFA_EMAIL_KEY,
    label: 'Email',
    buttonLabel: 'Set Up Email'
  },
  {
    kind: MFA_SMS_KEY,
    value: MFA_SMS_KEY,
    label: 'Phone Number for text message',
    buttonLabel: 'Set Up Text Message'
  }
];

export const loadAuthenticatorMaps = async () => {
  const { mfa_enabled: mfaEnabled, mfa_methods: mfaMethods } = await req.mfaGetAuthenticators();
  return mapAuthenticators(mfaMethods, mfaEnabled);
};

export const mapAuthenticators = (mfaMethods, mfaEnabled) => {
  const authenticators = MFA_AUTHENTICATOR_DESCRIPTORS.map(descriptor => {
    const enabledAuthenticator = mfaMethods.find(a => a.kind === descriptor.kind);
    return {
      ...descriptor,
      ...enabledAuthenticator,
      enabled: !!enabledAuthenticator
    };
  });

  return {
    mfaEnabled,
    authenticators
  };
};
